import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
  components,
  directives,

  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },

  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#60a5fa', // Current --primary
          secondary: '#34d399', // Current --secondary
          error: '#ef4444', // Current --danger
          success: '#10b981', // Current --success
          warning: '#f59e0b', // Current --warning
          info: '#3b82f6',
          background: '#f9fafb',
          surface: '#ffffff',
        },
      },
      dark: {
        colors: {
          primary: '#60a5fa',
          secondary: '#34d399',
          error: '#ef4444',
          success: '#10b981',
          warning: '#f59e0b',
          info: '#3b82f6',
        },
      },
    },
  },

  defaults: {
    VBtn: {
      style: 'text-transform: none;', // Remove uppercase
      rounded: 'md', // 8px border radius (matches current)
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VCard: {
      elevation: 2,
      rounded: 'lg', // 12px border radius
    },
  },
})
